import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import Tour from 'reactour';
import {mainState} from '../../AppMainState';

const stepsDesktop = [
    {
        content: 'Welcome to Muscula demo. We will show You some basic features of Muscula.',
    },
    {
        selector: '[data-tut="sidebar"]',
        content: 'On the left you can see your projects and logs.',
    },
    {
        selector: '[data-tut="flatlist"]',
        content: 'In the middle you can browser your errors. When something bad happens you will see here new item immidiately.',
    },
    {
        selector: '[data-tut="uptimestatus"]',
        content: 'You can also see that service or website is avaiable. URL for uptime monitoring you can set in log settings.',
    },
    {
        selector: '[data-tut="flatdetailsheader"]',
        content: 'On the right you can see details of error. When it happened, in which file exception was thrown. ' +
            'Every section can be expanded to browse the details.',
    },
    {
        content: 'It\'s all! To start using Muscula just create free account. Now you can close tutorial so you can play along.',
    },
    // ...
];

const stepsTablet = [
    {
        content: 'Welcome to Muscula demo. We will show You some basic features of Muscula.',
    },
    {
        selector: '[data-tut="bottombar"]',
        content: 'On the bottom you can switch between projects, assigned or starred bugs.',
    },
    {
        selector: '[data-tut="flatlist"]',
        content: 'On the left you can browser your errors. When something bad happens you will see here new item immidiately.',
    },
    {
        selector: '[data-tut="uptimestatus"]',
        content: 'You can also see that service or website is avaiable. URL for uptime monitoring you can set in log settings.',
    },
    {
        selector: '[data-tut="flatdetailsheader"]',
        content: 'On the right you can see details of error. When it happened, in which file exception was thrown. ' +
            'Every section can be expanded to browse the details.',
    },
    {
        content: 'It\'s all! To start using Muscula just create free account. Now you can close tutorial so you can play along.',
    },
    // ...
];


const stepsMobile = [
    {
        content: 'Welcome to Muscula demo. We will show You some basic features of Muscula. ' +
            'Please keep in mind that mobile version is intended only for ad hoc checks, not daily usage.  ' +
            'Please let us know when You find any use other use cases. ',
    },
    {
        selector: '[data-tut="bottombar"]',
        content: 'On the bottom you can switch between projects, assigned or starred bugs.',
    },
    {
        selector: '[data-tut="item-toggle"]',
        content: 'On the top you can switch between the bugs.',
    },
    {
        selector: '[data-tut="flatdetailsheader"]',
        content: 'Here you can see details of error. When it happened, in which file exception was thrown. ' +
            'Every section can be expanded to browse the details.',
    },
    {
        selector: '[data-tut="helpbutton"]',
        content: 'It\'s all! To start using Muscula just create free account. Now you can close tutorial so you can play along. ' +
            'If you have any  questions or suggestions please press the help button',
    },
];

export interface MusculaTourProps {

}

export const MusculaTour: FunctionComponent<MusculaTourProps> = observer(() => {
    let steps = stepsDesktop;
    if (window.innerWidth < 1280) {
        steps = stepsTablet;
    }

    if (window.innerWidth < 768) {
        steps = stepsMobile;
    }

    return <div>
        <Tour
            steps={steps}
            isOpen={mainState.isTourOpen}
            onRequestClose={() => mainState.setIsTourOpen(false)}
            accentColor="#82B139"
            className="bg-m-gray-1"
        />
    </div>;
});
